<template>
    <div class="GroupsContainer">
        <GroupItem
            v-for="group in groups"
            :key="group.key"
            :group="group"
            @delete="deleteGroup"
            @save="saveGroup"
        />
        <DeleteGroupModal
            :isOpen="deleteGroupModalOpen"
            :entityKey="entityKey"
            :group="deletingGroup"
            :groups="groups"
            :fields="fields"
            @refreshGroups="refreshGroups"
            @close="closeDeleteGroupModal"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { Api, apiRequest } from '@/api'
import GroupItem from './GroupItem.vue'
import DeleteGroupModal from './DeleteGroupModal.vue'

export default {
    name: 'GroupsContainer',
    components: { GroupItem, DeleteGroupModal },
    props: {
        entityKey: VueTypes.string,
        groups: VueTypes.array,
        fields: VueTypes.array,
    },
    data () {
        return {
            values: [],
            deleteGroupModalOpen: false,
            deletingGroup: {},
        }
    },
    methods: {
        refreshGroups () {
            this.$emit('refreshGroups')
        },
        saveGroup (group) {
            const { entityKey } = this
            const { key, name, icon } = group
            const params = { name, icon }
            apiRequest(Api().entities.editGroup({ entityKey, groupKey: key, params }))
                .then(() => this.refreshGroups())
        },
        deleteGroup (group) {
            this.deleteGroupModalOpen = true
            this.deletingGroup = group
        },
        closeDeleteGroupModal () {
            this.deleteGroupModalOpen = false
            this.deletingGroup = {}
        },
    },
}
</script>

<style scoped lang="scss">
.GroupsContainer {
    display: flex;
    flex: 1;
    flex-direction: column;
    max-width: 960px;
    margin: 0 auto;
    gap: 15px;
}
</style>
